<script>
	export let x = 0;
	export let y = 0;
	export let width = 640;
	export let height = 360;
	export let flip = false;
	export let title = "";
	export let rows = [];
	export let inline = false;
	export let onLeave = null;
	let measuredWidth = 0;
	let measuredHeight = 0;
	$: left = Math.max(8, Math.min(width - measuredWidth - 8, flip ? x - measuredWidth - 12 : x + 12));
	$: top = Math.max(8, Math.min(height - measuredHeight - 8, y));
</script>

<div
	class="tooltip"
	class:inline
	role={inline ? undefined : "tooltip"}
	data-export="skip"
	bind:offsetWidth={measuredWidth}
	bind:offsetHeight={measuredHeight}
	style={inline ? undefined : `left:${Math.round(left)}px; top:${Math.round(top)}px; max-height:${Math.max(40, height - 16)}px`}
	on:pointerleave={(e) => e.pointerType !== "touch" && onLeave && onLeave()}
>
	{#if title}<div class="title">{title}</div>{/if}
	{#each rows as r}
		<div class="row" class:total={r.total}>
			<span class="key" style="--c:{r.color || 'transparent'}" aria-hidden="true"></span>
			<span class="name">{r.name || "Valoare"}</span>
			<strong class="value">{r.value}</strong>
		</div>
	{/each}
</div>

<style>
	.tooltip {
		position: absolute;
		z-index: 2;
		box-sizing: border-box;
		width: max-content;
		max-width: min(320px, calc(100% - 16px));
		overflow: auto;
		padding: 12px 14px;
		background: var(--_surface);
		color: var(--_ink);
		border: 1px solid var(--_grid);
		border-radius: 6px;
		box-shadow: 0 4px 16px #00000014;
		font: 400 14px / 1.45 var(--_font);
		overflow-wrap: anywhere;
	}
	.tooltip.inline {
		position: static;
		width: 100%;
		max-width: none;
		padding: 0;
		border: 0;
		border-radius: 0;
		box-shadow: none;
		background: transparent;
		overflow: visible;
	}
	.title { color: var(--_ink); margin-bottom: 8px; font-weight: 600; }
	.row { display: grid; grid-template-columns: 10px minmax(0, 1fr) auto; align-items: baseline; gap: 8px; margin-top: 4px; }
	.row.total { border-top: 1px solid var(--_grid); margin-top: 8px; padding-top: 8px; }
	.key { width: 8px; height: 8px; background: var(--c); border-radius: 2px; align-self: center; }
	.value { max-width: 150px; text-align: right; font-variant-numeric: tabular-nums; font-family: var(--_num-font); }
	.name { color: var(--_ink-muted); min-width: 0; }
</style>
